var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"box-center data-analytics"},_vm._l((_vm.cards),function(card){return _c('data-card',{attrs:{"type":card.type,"data":card.text,"value":_vm.datacards[card.value]}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }